"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKpiAlertOperations = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = require("react");
var model_1 = require("../../../../model");
function useKpiAlertOperation(commandCreator, onSuccess) {
    var _a = tslib_1.__read(react_1.useState("idle"), 2), status = _a[0], setStatus = _a[1];
    var dispatch = model_1.useDashboardDispatch();
    var run = react_1.useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        setStatus("inProgress");
        model_1.dispatchAndWaitFor(dispatch, commandCreator.apply(void 0, tslib_1.__spread(args)))
            .then(function () {
            setStatus("idle");
            onSuccess();
        })
            .catch(function () { return setStatus("error"); });
    }, [onSuccess]);
    return [status, run];
}
exports.useKpiAlertOperations = function (closeAlertDialog) {
    var _a = tslib_1.__read(useKpiAlertOperation(model_1.createAlert, closeAlertDialog), 2), creatingStatus = _a[0], onCreateAlert = _a[1];
    var _b = tslib_1.__read(useKpiAlertOperation(model_1.updateAlert, closeAlertDialog), 2), updatingStatus = _b[0], onUpdateAlert = _b[1];
    var _c = tslib_1.__read(useKpiAlertOperation(model_1.removeAlerts, closeAlertDialog), 2), removingStatus = _c[0], onRemoveAlerts = _c[1];
    var onRemoveAlert = react_1.useCallback(function (alert) {
        onRemoveAlerts([alert.ref]);
    }, [onRemoveAlerts]);
    return {
        onCreateAlert: onCreateAlert,
        creatingStatus: creatingStatus,
        onUpdateAlert: onUpdateAlert,
        updatingStatus: updatingStatus,
        onRemoveAlert: onRemoveAlert,
        removingStatus: removingStatus,
    };
};
//# sourceMappingURL=useKpiAlertOperations.js.map